var mapBoxToken = ''
if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  mapBoxToken = 'pk.eyJ1Ijoic2hlZW5hdmVyZGFkIiwiYSI6ImNqczluMmgwczB3eDE0M3A4b214eXdpNnAifQ.lLWyueusm4W2jxVaB1j9rA'
  // mapBoxToken = 'http://sustainabilitybackend.geodemosolutions.com/'
 }
else {
  mapBoxToken = 'pk.eyJ1IjoicXVpbmVzbGEiLCJhIjoiY2pzOW16NmthMHo4bTQ0bGlic3VjZGtsdyJ9.ggMkRs_gY9KGy3IiPcmkxw'
  // mapBoxToken = 'http://localhost:8000/'

}

export {
  mapBoxToken
}
